module.exports = __webpack_public_path__ + "./images/df391c4c9068fdde1b913c750b9ff212.webp";